import { TAdornmentType } from 'packages/Tags/shared/types/tag';
import { UndergroundIcon } from './UndergroundIcon';
import { UndergroundReleaseYear } from './UndergroundReleaseYear';
import { FC } from 'react';

export const ADORNMENTS: Record<TAdornmentType, FC> = {
  undergroundIcon: UndergroundIcon,
  undergroundReleaseYear: UndergroundReleaseYear,
};
